module.exports = __webpack_public_path__ + "img/pascual-cervera.1cf62c38.png";